import router, { dynamicRoutes, staticRoutes } from "@/router";
import { AppModule } from "@/store/modules/app";
import { PermissionModule } from "@/store/modules/permission";
import { UserModule, redirectLogin } from "@/store/modules/user";
import NProgress from "nprogress"; // Progress 进度条
import "nprogress/nprogress.css"; // Progress 进度条样式
import { Message } from "element-ui";
// 不重定向白名单
const whiteList = ["/error/404"];
// 需要清除query的名单
const noqueryList = ["/error/404"];
// 重定向时过滤掉权限相关的query字段 不显示在地址栏中
const permissionQuery = ["email", "menuCode", "ssoUserId", "token"];
/**
 * 校验路由权限是否授权
 * @param permissions 权限列表
 * @param route 路由
 * @returns 是否授权
 */
const hasPermission = (permissions, route) => {
    if (route.meta && route.meta.permissions) {
        return permissions.some((permission) => route.meta.permissions === permission);
    }
    else {
        return true;
    }
};
/**
 * 过滤掉没有权限的路由
 * @param routes 路由列表
 * @param permissions 权限列表
 * @returns 过滤后的路由列表
 */
const filterRoutes = (routes, permissions) => {
    const res = [];
    routes.forEach((route) => {
        const _route = { ...route };
        if (hasPermission(permissions, _route)) {
            if (_route.children) {
                _route.children = filterRoutes(_route.children, permissions);
            }
            res.push(_route);
        }
    });
    return res;
};
/**
 * 解析参数字符串
 * @param query 参数字符串
 * @returns 参数对象
 */
const parseQueryString = (qs) => {
    const query = {};
    const pairs = qs.split(/[?&]/);
    let match = null;
    pairs.reduce((acc, cur) => {
        if (match = cur.match(/^([^=]+)=([^=]*)$/)) {
            acc[match[1]] = match[2];
        }
        return acc;
    }, query);
    return query;
};
router.beforeEach(async (to, _, next) => {
    NProgress.start(); // 开始progress
    // 检查是否白名单页面 白名单不需要登录 否则鉴权
    if (whiteList.includes(to.path)) {
        next();
    }
    else {
        // 检查vuex中是否已存在token
        if (UserModule.token && UserModule.ssoId) {
            if (to.path === '/login') {
                // 重定向login页到首页 注意：因采用单点登录的原因，该系统不存在login页面
                next({ path: '/', replace: true });
            }
            else {
                // 检查权限列表是否为空 为空则获取权限列表
                if (UserModule.permissions.length === 0) {
                    try {
                        const isAuthorize = await UserModule.authorize();
                        if (!isAuthorize) {
                            NProgress.done();
                            return Message.error("所在账户没有访问权限");
                        }
                        // 根据权限列表生成动态路由
                        const accessRoutes = filterRoutes(dynamicRoutes, UserModule.permissions);
                        PermissionModule.setRoutes(staticRoutes.concat(accessRoutes));
                        // 向路由中添加动态路由 注意：router.addRoutes()已弃用
                        // accessRoutes.forEach(route => router.addRoute(route));
                        // 锁定vue-router版本为3.1.3 沿用旧版方法
                        router.addRoutes(accessRoutes);
                        next({ ...to, replace: true });
                    }
                    catch (err) {
                        // 清除已有token并重定向到login页
                        Message.error("获取授权失败");
                        UserModule.logout();
                        NProgress.done();
                    }
                }
                else {
                    // 检查地址是否存在于无query列表中 如有则清除query 可通过noqueryList配置
                    if (noqueryList.includes(to.path) &&
                        Object.keys(to.query).length > 0) {
                        next({ path: to.path, replace: true });
                    }
                    else {
                        next();
                    }
                }
            }
        }
        else {
            // const query: Record<string, string> = to.query as Record<string, string>;
            // 由于单点登录系统的参数拼接存在问题，需自行解析query
            // p.s. ?id=67?token=b41fd44af9f455a74763fbb4ab57e4ac
            const qs = decodeURIComponent(to.fullPath.replace(to.path, ''));
            const query = parseQueryString(qs);
            // 检查是否通过query传递token信息 如无则跳转登录
            if (query.token) {
                UserModule.setAuth(query); // 储存token信息
                // 过滤权限相关的query字段 使其不显示在地址栏中 可通过permissionQuery配置
                const _query = {};
                for (const key in query) {
                    if (Object.prototype.hasOwnProperty.call(query, key) &&
                        !permissionQuery.includes(key)) {
                        _query[key] = query[key];
                    }
                }
                next({ path: to.path, query: _query, replace: true });
            }
            else {
                redirectLogin(); // 跳转登录界面
            }
        }
    }
});
router.afterEach((to) => {
    NProgress.done(); // 结束Progress
    if (to.meta && to.meta.preventTab)
        return; // 不添加路由历史记录
    // 遍历记录查看当前路由是否已存在历史记录中
    const index = AppModule.history.findIndex((r) => r.name === to.name);
    if (index !== -1) {
        // 已存在则设置当前路由
        const current = AppModule.history[index];
        current.params = to.params;
        current.query = to.query;
        AppModule.setCurrent(current);
    }
    else {
        // 否则新增路由历史记录
        AppModule.pushHistory({
            name: to.name || "",
            title: (to.meta && to.meta.title) || "",
            params: to.params,
            path: to.path,
            query: to.query,
        });
    }
});
